import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDreamteam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	role: "img",
	focusable: "false",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7710_442827)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z",
			fill: "#37003C"
		}), /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_7710_442827)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.99999 6.78478L2.94002 7.86772L3.33332 5.57411L1.66666 3.9495L3.97001 3.61461L4.99999 1.52777L6.02997 3.61461L8.33332 3.9495L6.66666 5.57411L7.05996 7.86772L4.99999 6.78478Z",
				fill: "#00FF87"
			})
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7710_442827",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 10,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_7710_442827",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 6.66667,
			height: 6.66667,
			fill: "white",
			transform: "translate(1.66666 1.25)"
		})
	})] })]
});
export default SvgDreamteam;
